export const HASH_EXCEPTION_DETAILS_ERROR = 'HASH_EXCEPTION_DETAILS_ERROR';
export const HASH_EXCEPTION_DETAILS = 'HASH_EXCEPTION_DETAILS';
export const HASH_EXCEPTION_DETAILS_PROGRAM = 'HASH_EXCEPTION_DETAILS_PROGRAM';
export const LOADING_HASH_EXCEPTION_DETAILS = 'LOADING_HASH_EXCEPTION_DETAILS';
export const UPDATE_NOTES = 'UPDATE_NOTES';
